// import { FORM_KEYS } from 'shared/constant';

// const { CLIENT_DETAILS } = FORM_KEYS;

const countries = ['Kuwait', 'Abkhazia', 'Afghanistan', 'Aland', 'Algeria', 'American Samoa', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahamas', 'Bahrain', 'Bangladesh', 'Belgium', 'Bermuda', 'Brazil', 'British Virgin Islands', 'Bulgaria', 'Burma', 'Canada', 'Cayman Islands', 'Channel Islands', 'China', 'Colombia', 'Cook Islands', 'Cyprus', 'Denmark', 'Djibouti', 'Egypt', 'Ethiopia', 'European Union', 'Finland', 'France', 'French Guiana', 'General', 'Germany', 'Gibraltar', 'Greece', 'Greenland', 'Guadeloupe', 'Guam', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Japan', 'Jersey', 'Jordan', 'Korea', 'Lebanon', 'Liberia', 'Libya', 'Luxembourg', 'Macau', 'Malaysia', 'Martinique', 'Mexico', 'Moldova', 'Monaco', 'Montenegro', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Helena', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'U.S. Virgin Islands', 'UAE', 'Uganda', 'Ukraine', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'];

const nationalities = [
  'Kuwaiti', 'Afghanistan', 'Algerian', 'American', 'Arethria', 'Australian', 'Austria', 'Bahamian', 'Bahrain', 'Bangladeshi', 'Belgium', 'Brazil', 'British', 'Canadian', 'Caymen Islands', 'China', 'Cypris', 'Czechs', 'Dominican', 'Egyptian', 'Emirates', 'Eritria', 'Filipino', 'finland', 'French', 'Germany', 'Hong kong', 'Hungary', 'Indian', 'Iranian', 'Iraqi', 'Irland', 'Italy', 'Japan', 'Jersey', 'Jordanian', 'Korea', 'Lebanese', 'Liberia', 'luxomburg', 'Malaysia', 'Moroccan', 'Nepal', 'Netherlands Antilles', 'Netherlands', 'New Zealand', 'Nigerian', 'Oman', 'Pakistani', 'Palestinian', 'Polland', 'Portuguese', 'Qatar', 'Russian', 'Saudi', 'Senegali', 'Singapore', 'Soumali', 'Spain', 'Sri Lanka', 'Sudanese', 'Swedian', 'Switzerland', 'Syrian', 'Tunisi', 'Turkish', 'Virgin Island', 'Yamen',
];

const jurisdictions = [
  'Kuwait',
  'Bahrain',
  'Brunei',
  'China',
  'Hong Kong',
  'India',
  'Indonesia',
  'Japan',
  'Lebanon',
  'Macau',
  'Malaysia',
  'Mauritius',
  'Qatar',
  'Saudi Arabia',
  'Singapore',
  // 'South Korea',
  'United Arab Emirates',

  'Ghana',
  'Seychelles',
  'South Africa',

  'Argentina',
  'Belize',
  'Brazil',
  'Canada',
  'Chile',
  'Colombia',
  'Costa Rica',
  'Mexico',
  'Panama',
  'Uruguay',

  'Andorra',
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guernsey',
  'Hungary',
  'Iceland',
  'Ireland',
  'Isle of Man',
  'Italy',
  'Jersey',
  'Latvia',
  'Lichtenstein',
  'Luxembourg',
  'Malta',
  'Monaco',
  'Netherlands',
  'Norway',
  'Poland',
  'Portugal',
  'Romania',
  'Russia',
  'San Marino',
  'Slovak Republic',
  'Spain',
  'Sweden',
  'Switzerland',
  'United Kingdom',

  'Australia',
  'Cook Islands',
  'Marshall Islands',
  'Nauru',
  'Niue',
  'Samoa',
  'Vanuatu',

  'Anguilla',
  'Antigua and Barbuda',
  'Aruba',
  'Bahamas',
  'Barbados',
  'Bermuda',
  'British Virgin Island',
  'Cayman Islands',
  'Curacaos',
  'Dominica',
  'Faroe Islands',
  'Montserrat',
  'Saint Kitts and Nevis',
  'Saint Lucia',

  'Saint Maarten',
  'Saint Vincent and the Grenadines',
  // 'Trinidad and Tobago',

  'Albania',
  'Azerbaijan',
  'Ecuador',
  'Egypt',
  'New Caledonia',
  'Israel',
  'Kazakhstan',
  'Kenya',
  'Korea',
  'Liberia',
  'Lithuania',
  'Maldives',
  'Morocco',
  'New Zealand',
  'Nigeria',
  'Oman',
  'Pakistan',
  'Peru',
  'Slovenia',
  'Turkey',
  'Turks & Caicos Island',
];

// const classificationOptions = [
//   { id: 'retail', label: 'clientDetails.classification.retail' },
//   { id: 'qualified', label: 'clientDetails.classification.qualified' },
// ];

// const typeOfInvestmentOptions = [
//   { id: 'imarkazPortfolio', label: 'clientDetails.classification.markazPortfolio' },
//   { id: 'mutualFunds', label: 'clientDetails.classification.mutualFundsOnly' },
// ];

// const qualifiedTypeOfInvestmentOptions = [
//   { id: 'discretionary', label: 'clientDetails.classification.discretionary' },
//   { id: 'nonDiscretionary', label: 'clientDetails.classification.nonDiscretionary' },
// ];

// const productOptions = [
//   { id: 'mumtaz', label: 'clientDetails.classification.mumtaz' },
//   { id: 'islamic', label: 'clientDetails.classification.islamic' },
// ];

// const qualifiedOptions = [
//   { id: 'qualifiedOption1', label: 'clientDetails.classification.qualified.option1' },
//   { id: 'qualifiedOption2', label: 'clientDetails.classification.qualified.option2' },
//   { id: 'qualifiedOption3', label: 'clientDetails.classification.qualified.option3' },
// ];

const fatcaCrsOptions = [
  { id: 'yes', label: 'yes' },
  { id: 'no', label: 'no' },
];

// const sourcesOfFunds = [
//   'sourceOfWealth.employment',
//   'sourceOfWealth.inheritance',
//   'sourceOfWealth.investments',
//   'sourceOfWealth.trade',
//   'sourceOfWealth.savings',
//   'sourceOfWealth.others',
// ];

// const estimatedWealthOptions = [
//   { id: 'estimatedWealthOption1', label: 'estimatedWealth.option1' },
//   { id: 'estimatedWealthOption2', label: 'estimatedWealth.option2' },
//   { id: 'estimatedWealthOption3', label: 'estimatedWealth.option3' },
//   { id: 'estimatedWealthOption4', label: 'estimatedWealth.option4' },
// ];

// const netAssetOptions = [
//   { id: 'netAssetOption1', label: 'netAssets.option1' },
//   { id: 'netAssetOption2', label: 'netAssets.option2' },
//   { id: 'netAssetOption3', label: 'netAssets.option3' },
//   { id: 'netAssetOption4', label: 'netAssets.option4' },
// ];

// const netIncomeOptions = [
//   { id: 'netIncomeOption1', label: 'netIncome.option1' },
//   { id: 'netIncomeOption2', label: 'netIncome.option2' },
//   { id: 'netIncomeOption3', label: 'netIncome.option3' },
//   { id: 'netIncomeOption4', label: 'netIncome.option4' },
// ];

const defaultBoolOptions = [
  { id: 'yes', label: 'yes' },
  { id: 'no', label: 'no' },
];

// const banks = [
//   'National Bank of Kuwait (K.S.C)',
//   'Commercial Bank of Kuwait (K.S.C)',
//   'Gulf Bank (K.S.C)',
//   'Al Ahli Bank of Kuwait (K.S.C.P.)',
//   'Al Ahli United Bank',
//   'Burgan Bank (K.S.C)',
//   'Kuwait International Bank (K.S.C)',
//   'The Industrial Bank of Kuwait (K.S.C)',
//   'Kuwait Finance House',
//   'Boubyan Bank (K.S.C)',
//   'Warba Bank',
//   'Others',
// ];

// const currencies = [
//   'KWD',
//   'AED',
//   'EUR',
//   'SAR',
//   'USD',
// ];

// const investmentGoals = [
//   'investmentGoal.childrensEducation',
//   'investmentGoal.savingForRetirement',
//   'investmentGoal.bigPurchase',
//   'investmentGoal.legacy',
//   'investmentGoal.additionalIncome',
//   'investmentGoal.generalInvestment',
// ];

// const investmentPurposes = [
//   'investmentPurposes.capitalGrowth',
//   'investmentPurposes.diversification',
//   'investmentPurposes.income',
//   'investmentPurposes.liquidity',
//   'investmentPurposes.manageControllingStake',
//   'investmentPurposes.other',
// ];

// const riskTolerances = [
//   'Very low',
//   'Low',
//   'Moderate',
//   'High',
//   'Very High',
// ];

// const investmentExpYears = [
//   'none',
//   '1 year',
//   '2 years',
//   '3 years',
//   '4 years',
//   '5 years',
//   '5 years & above',
// ];

// const investmentExpStrategies = [
//   'Short term trading',
//   'Medium term investments',
//   'Long term investments',
// ];

const investmentObjectiveTimeHorizons = [
  { objective: 'Income', timeHorizon: '3 months', liquidityGrowth: '100% : 0' },
  { objective: 'Income & Growth', timeHorizon: '6 months - 1 year', liquidityGrowth: '75% : 25%' },
  { objective: 'Growth & Income', timeHorizon: '1 year', liquidityGrowth: '50% : 50%' },
  { objective: 'Growth', timeHorizon: '2 - 3 years', liquidityGrowth: '25% : 75%' },
  { objective: 'Aggressive Growth', timeHorizon: 'Long term', liquidityGrowth: '0 : 100%' },
];

// const assetClasses = [
//   'No restrictions',
//   'Bonds',
//   'Equities',
//   'Private Equity & Hedge funds',
//   'Real estate',
//   'Other Alternative Investments',
// ];

// const marketOptions = [
//   { id: 'marketOption1', label: 'markets.option1' },
//   { id: 'marketOption2', label: 'markets.option2' },
//   { id: 'marketOption3', label: 'markets.option3' },
//   { id: 'marketOption4', label: 'markets.option4' },
//   { id: 'marketOption5', label: 'markets.option5' },
// ];

// const investmentMaturityTargets = [
//   'High/Short (< 3 months)',
//   'Medium (3 months – 1 year)',
//   'Low/Long ( > 1 year)',
// ];

// const investmentKnowledges = [
//   'Poor',
//   'Good',
//   'Professional',
// ];

// const restrictionOptions = [
//   { id: 'restrictionOption1', label: 'restriction.option1' },
//   { id: 'restrictionOption2', label: 'restriction.option2' },
//   { id: 'restrictionOption3', label: 'restriction.option3' },
//   { id: 'restrictionOption4', label: 'restriction.option4' },
//   { id: 'restrictionOption5', label: 'restriction.option5' },
// ];

const positionOptions = [
  { id: 'current', label: 'current' },
  { id: 'former', label: 'former' },
];

const taxReasonOptions = [
  { id: 'REASON-A', label: 'countryTax.reasonA' },
  { id: 'REASON-B', label: 'countryTax.reasonB' },
  { id: 'REASON-C', label: 'countryTax.reasonC' },
];

const agreementOptions = [
  { id: 'agree1', label: 'agreement.option1' },
  { id: 'agree2', label: 'agreement.option2' },
  // { id: 'agree3', label: 'agreement.option3' },
  // { id: 'agree4', label: 'agreement.option4' },
];

const agreementAofKycOptions = [
  { id: 'AGREE-AOF-KYC-01', label: 'agreements.aofKyc.option1', isChecked: false },
  { id: 'AGREE-AOF-KYC-02', label: 'agreements.aofKyc.option2', isChecked: false },
  { id: 'AGREE-AOF-KYC-03', label: 'agreements.aofKyc.option3', isChecked: false },
];

const agreementProfileOptions = [
  { id: 'AGREE-PROFILE-01', label: 'agreements.profile.option1' },
  { id: 'AGREE-PROFILE-02', label: 'agreements.profile.option2' },
];

const occupationOptions = [
  { id: 'EMPLOYEE', label: 'occupation.employee' },
  { id: 'SELF_EMPLOYED', label: 'occupation.selfemployed' },
  { id: 'MINOR', label: 'occupation.minor' },
  { id: 'HOUSEWIFE', label: 'occupation.housewife' },
  { id: 'RETIRED', label: 'occupation.retired' },
];
const occupationNA = ['NW-MAR-OCC-MN', 'NW-MAR-OCC-HW', 'NW-MAR-OCC-RE'];

/** Export here */
const arrOptions = {
  // classificationOptions,
  // typeOfInvestmentOptions,
  // qualifiedTypeOfInvestmentOptions,
  // productOptions,
  // qualifiedOptions,
  fatcaCrsOptions,

  taxReasonOptions,
  jurisdictions,
  countries,
  nationalities,

  // sourcesOfFunds,
  // estimatedWealthOptions,
  // netAssetOptions,
  // netIncomeOptions,

  // banks,
  // currencies,
  // investmentGoals,
  // investmentPurposes,
  // riskTolerances,
  // investmentExpYears,
  // investmentExpStrategies,
  investmentObjectiveTimeHorizons,
  // assetClasses,
  // marketOptions,
  // investmentMaturityTargets,
  // investmentKnowledges,
  // restrictionOptions,

  defaultBoolOptions,
  positionOptions,

  agreementOptions,
  agreementAofKycOptions,
  agreementProfileOptions,

  occupationOptions,
  occupationNA,
};

export default arrOptions;
